import { Routes } from '@angular/router';
import { AuthLayout } from '../layouts/auth-layout/auth-layout';
import { AdminLayout } from '../layouts/admin-layout/admin-layout';
import { authGuard } from '../core/guards/auth.guard';
import { noAuthGuard } from '../core/guards/no-auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    component: AuthLayout,
    canActivate: [noAuthGuard],
    loadChildren: () => import('../routes/auth.routes').then(m => m.authRoutes)
  },
  {
    path: 'admin',
    component: AdminLayout,
    canActivate: [authGuard],
    loadChildren: () => import('../routes/admin.routes').then(m => m.adminRoutes)
  },
  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full'
  }
];
